import React from 'react';
import { h3, h5 } from '../../fontSizes';
import { Container } from '../Containers';
import { smallMargin } from '../../margins';

export const OpeningHours = ({ openingHours }) => {
  if (!openingHours || !openingHours.length) {
    return null;
  }
  return (
    <Container
      css={`
        margin-bottom: ${smallMargin};
      `}
    >
      <h2
        css={`
          font-size: ${h3};
          text-align: center;
          margin-bottom: ${smallMargin};
        `}
      >
        Öppettider
      </h2>
      {openingHours.map(({ title, times }) => (
        <div
          css={`
            margin-bottom: ${smallMargin};
          `}
          key={title}
        >
          {title && (
            <div
              css={`
                font-size: ${h5};
                font-weight: bold;
                text-align: center;
                margin-bottom: ${smallMargin};
              `}
            >
              {title}
            </div>
          )}
          <div
            css={`
              display: flex;
              justify-content: center;
            `}
          >
            <div>
              {times &&
                times
                  .filter(
                    ({ day, time }) => day.trim().length || time.trim().length
                  )
                  .map(({ day, time }) => (
                    <div
                      css={`
                        display: flex;
                        justify-content: space-between;
                        min-width: 100px;
                        margin-bottom: ${smallMargin};
                      `}
                      key={day + time}
                    >
                      {day.trim().length > 0 && (
                        <div
                          css={`
                            margin-right: 1ch;
                          `}
                        >
                          {day}
                        </div>
                      )}
                      {time.trim().length > 0 && (
                        <div
                          css={`
                            font-weight: bold;
                          `}
                        >
                          {time}
                        </div>
                      )}
                    </div>
                  ))}
            </div>
          </div>
        </div>
      ))}
    </Container>
  );
};



// WEBPACK FOOTER //
// ./app/components/ContactSection/OpeningHours.js